module.exports = __webpack_public_path__ + "759e6f652c0c19075d1502f5714ed2b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/spiral-notebook.png
// module id = 2741
// module chunks = 0